import AcademicYearTitle from 'components/pdfStudent/AcademicYearTitle';
import { useAppSelector } from 'hooks';
import AnalyticsDiagrams from 'portfolio3/features/diagnostics/components/AnalyticsDiagrams';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';

import { IIndependentDiagnosticLearningGroup } from '../../../../api/types';
import IndependentDiagnosticList from './IndependentDiagnosticList';

import './index.scss';

type IndependentDiagnosticProps = {
  independentDiagnostics: IIndependentDiagnosticLearningGroup[];
};

const IndependentDiagnosticComponent = ({ independentDiagnostics }: IndependentDiagnosticProps) => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const sortedDiagnosticSubjects = independentDiagnostics
    ?.filter((diagnostic) => academicYears.includes(diagnostic.learningYear))
    ?.sort((firstItem, secondItem) => secondItem.learningYear.localeCompare(firstItem.learningYear));

  return (
    sortedDiagnosticSubjects &&
    sortedDiagnosticSubjects?.length !== 0 && (
      <>
        {sortedDiagnosticSubjects.map((diagnostic) => (
          <div key={diagnostic.learningYear}>
            <AcademicYearTitle academicYear={diagnostic.learningYear} />
            <AnalyticsDiagrams diagnostics={diagnostic.diagnostics} />
            <div className="pdf-divider-diagnostics" />
            <IndependentDiagnosticList diagnostics={diagnostic.diagnostics.diagnostic} />
          </div>
        ))}
      </>
    )
  );
};

export default IndependentDiagnosticComponent;
